import { Link, NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaCarSide,
  FaCar,
  FaCarAlt,
  FaCogs
} from "react-icons/fa";

const Sidebar = () => {
  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-6 py-3 rounded transition ${isActive
      ? "bg-[#56a5a9] text-[#010101]"
      : "text-white hover:bg-white/10"
    }`;

  return (
    <aside className="w-64 bg-[#203d41] text-white flex flex-col">

      <Link to="/">

        <div className="p-6 text-xl font-bold border-b border-white/10">
          CMS Admin
        </div>
      </Link>

      <nav className="flex-1 p-4 space-y-2">

        <div className="mt-4 text-xs uppercase text-white/50 px-6">
          Models
        </div>

        <NavLink to="/dashboard/contentpage" className={linkClass}>
          <FaCarSide size={18} />
          <span>Models</span>
        </NavLink>


      </nav>
    </aside>
  );
};

export default Sidebar;
